function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { Tone } from "./Chip.types";
import { ClearableChip } from "./ClearableChip";
import { DarkToneChip } from "./DarkToneChip";
import { LightToneChip } from "./LightToneChip";
var Chip = /*#__PURE__*/React.forwardRef(function (props, ref) {
  if (props.clearable) {
    var clearableChipProps = props;
    return /*#__PURE__*/React.createElement(ClearableChip, _extends({
      clearable: true
    }, clearableChipProps, {
      ref: ref
    }));
  }

  if (!props.clearable && props.tone === Tone.dark) {
    var darkChipProps = props;
    return /*#__PURE__*/React.createElement(DarkToneChip, _extends({}, darkChipProps, {
      ref: ref
    }));
  }

  var lightToneChipProps = props;
  return /*#__PURE__*/React.createElement(LightToneChip, _extends({}, lightToneChipProps, {
    ref: ref
  }));
}); //#region Constraints imposed on Chip by the Design System:

/** Chip variants
 * 1. Chips can have following tones
 *  1. dark (implemented because of legacy requirements, not recommended for use,
 *    will be deprecated in future)
 *  2. light
 * 2. Chips can have following palette values
 *  1. primary
 *  2. neutral
 *  3. info
 *  4. danger
 *  5. success
 *  6. white
 * 3. Chips can support an optional Left Icon which is
 *  1. Not clickable at the icon level
 *  2. Not hoverable at the icon level
 *  3. Of size 16px for medium-sized chip, 12px for small-sized chip
 * 4. Chips can support an optional Right Icon which is
 *  1. Clickable at the icon level if an onRightClick handler is passed
 *  2. Non hoverable at the icon level
 *  3. Of size 12px for medium-sized chip, 10px for small-sized chip
 * 5. Left or Right Icons are NOT allowed for dark-toned chips. If tone
 *  is set to dark, icons are ignored
 * 6. Chips can optionally be hoverable - onMouseOver is applied to the parent container
 * 7. Chips can optionally be clearable. When a chip is made clearable
 *  1. Tone if passed will be ignored and set to light
 *  2. Palette if passed will be ignored and set to neutral
 *  3. Right Icon is defaulted to cross icon
 *  4. onClear is passed down as onClick event listener to the right icon
 * 8. If a valid handler is provider via onRightIconClick (in case of non clearable chip)
 *  or onClear (in case of clearable chip), right icon's pointer is set to cursor
 *  to indicate it's clickable
 */
//#endregion

Chip.displayName = 'Chip';
export { Chip };
export default Chip;